export default __webpack_public_path__ + "static/media/illus_2FA_1.cadce182.svg";